<template>
  <div class>
    <Toast />

    <div class="card css-table">
      <h5>
        <b>Daftar Item Obral</b>
      </h5>
      <DataTable
        :value="list_items"
        :loading="loading.filter"
        :rowHover="true"
        :selection.sync="selectedItems"
      >
        <template #empty>Data tidak tersedia.</template>
        <template #loading
          >Menggambil data daftar barang obral. Mohon tunggu.</template
        >

        <template #header>
          <div class="p-grid p-fluid p-mb-3">
            <div class="p-col-12 p-md-6 p-lg-3">
              <AutoComplete
                placeholder="Pilih Barang"
                :dropdown="true"
                :multiple="false"
                v-model="selected_item"
                :suggestions="filtered_items"
                @complete="searchItem($event)"
                @input="is_error.items = false"
                field="code"
              >
                <template #item="slotProps">
                  <div>{{ slotProps.item.name }}</div>
                  <div style="font-style: italic; font-size: 12px">
                    {{ slotProps.item.code }}
                  </div>
                </template>
              </AutoComplete>
              <small class="p-error" v-if="is_error.items">{{
                error_msg.items
              }}</small>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3">
              <InputText placeholder="Nomer Bon" v-model="filter.doc_number" />
            </div>
            <div class="p-col-12 p-md-6 p-lg-3">
              <InputText type="date" v-model="filter.doc_date" />
            </div>
            <div class="p-col-12 p-md-6 p-lg-3">
              <button
                class="btn btn-primary"
                :disabled="loading.filter"
                @click="getList()"
                style="width: 100%"
              >
                Cari Barang Obral
                <span v-if="loading.filter">
                  <i class="pi pi-spin pi-spinner" style="fontsize: 12px"></i>
                </span>
              </button>
            </div>
          </div>
        </template>

        <Column field="cat_no" header="No" headerStyle="width: 3em">
          <template #body="slotProps">
            {{ list_items.indexOf(slotProps.data) + 1 }}
          </template>
        </Column>
        <Column header="Kode Barang" headerStyle="width: 12em;">
          <template #body="slotProps">
            <span> {{ slotProps.data.item_code }} </span>
          </template>
        </Column>
        <Column header="Nama Barang">
          <template #body="slotProps">
            <span> {{ slotProps.data.item_name }} </span>
          </template>
        </Column>
        <Column header="Jumlah">
          <template #body="slotProps">
            <span> {{ slotProps.data.qty }} </span>
          </template>
        </Column>
        <Column header="Harga">
          <template #body="slotProps">
            <span> {{ slotProps.data.price | currency }} </span>
          </template>
        </Column>
        <Column header="Nomor Bon">
          <template #body="slotProps">
            <span>{{ slotProps.data.doc_number }}</span>
          </template>
        </Column>
        <Column header="Tanggal Bon">
          <template #body="slotProps">
            <span>
              {{ slotProps.data.doc_date }}
            </span>
          </template>
        </Column>
        <Column selectionMode="multiple" headerStyle="width: 3em;"></Column>
      </DataTable>

      <div
        class="p-grid p-justify-center p-mt-4"
        v-if="list_items.length != 0 && selectedItems.length != 0"
      >
        <div class="p-col-12 p-md-6 p-lg-3">
          <button
            class="btn btn-primary"
            @click="prosesObral()"
            style="width: 100%"
          >
            Proses
          </button>
        </div>
      </div>

      <div class="p-col-header p-sm-12 p-md-6 p-lg-2">
        <Dialog
          :visible.sync="process_dialog"
          :style="{ width: '450px' }"
          header="Proses Obral"
          :modal="true"
          class="p-fluid"
        >
          <div class="p-field">
            <label>Supplier</label>
            <AutoComplete
              placeholder="Pilih Supplier"
              :dropdown="true"
              :multiple="false"
              v-model="supplier_selected"
              :suggestions="supplier_filtered"
              @complete="getSuppliers($event)"
              @input="is_error.supplier_id = false"
              field="code"
            >
              <template #item="slotProps">
                <div>{{ slotProps.item.name }}</div>
                <div style="font-style: italic; font-size: 12px">
                  {{ slotProps.item.code }}
                </div>
              </template>
            </AutoComplete>
            <p v-if="is_error.supplier_id" style="color: red">
              {{ error_msg.supplier_id }}
            </p>
          </div>

          <div class="p-field">
            <label for="doc_number">Nomor Bon</label>
            <div>
              <InputText
                class="form-control"
                v-model="process_data.doc_number"
                placeholder="Nomor Bon"
                @keyup.prevent="is_error.doc_number = false"
              />
            </div>
            <small class="p-error" v-if="is_error.doc_number">{{
              error_msg.doc_number
            }}</small>
          </div>

          <div class="p-field">
            <label for="doc_date">Tanggal Bon</label>
            <div>
              <InputText
                class="form-control"
                id="doc_date"
                type="date"
                v-model="process_data.doc_date"
                placeholder="Tanggal Bon"
                @change="is_error.doc_date = false"
              />
            </div>
            <small class="p-error" v-if="is_error.doc_date">{{
              error_msg.doc_date
            }}</small>
          </div>
          <template #footer>
            <Button
              label="Cancel"
              icon="pi pi-times"
              class="p-button-outlined"
              @click="process_dialog = false"
            />
            <Button
              label="Save"
              class="btn btn-primary"
              @click="saveClicked()"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require('moment')
export default {
  data() {
    return {
      moment: moment,

      loading: {
        filter: false
      },

      filter: {
        show_all: false,
        doc_number: '',
        doc_date: '',
        barcode_date: ''
      },

      process_dialog: false,

      items: [],
      list_items: [],
      filtered_items: [],
      selected_item: '',

      limit: 1000,

      selectedItems: [],
      selectedItems_id: '',
      ids: [],

      supplier_selected: null,
      supplier_filtered: [],

      barcodes: null,
      suppliers: null,

      process_data: {
        warehouse_sale_ids: [],
        sup_id: 0,
        doc_date: '',
        doc_number: ''
      },

      is_error: {
        items: false,
        supplier_id: false,
        doc_number: false,
        doc_date: false
      },

      error_msg: {
        items: '',
        supplier_id: '',
        doc_date: '',
        doc_number: ''
      }
    }
  },
  mounted() {
    this.getItems()
    this.getSuppliers()
    this.getList()
  },
  methods: {
    // !Not used
    // getSuppliers() {
    //   let code = ''
    //   if (this.supplier_selected instanceof Object) {
    //     code = this.supplier_selected.code
    //   } else {
    //     code = this.supplier_selected
    //   }

    //   this.$http
    //     .get(`${process.env.VUE_APP_API_URL}/suppliers?code=${code}&limit=5`)
    //     .then(response => {
    //       if (response.status === 200) {
    //         this.suppliers = response.data.data.suppliers
    //         this.supplier_filtered = this.suppliers

    //         if (this.supplier_filtered.length <= 0) {
    //           let name = ''
    //           if (this.supplier_selected instanceof Object) {
    //             name = this.supplier_selected.name
    //           } else {
    //             name = this.supplier_selected
    //           }

    //           this.$http
    //             .get(
    //               `${process.env.VUE_APP_API_URL}/suppliers?name=${name}&limit=5`
    //             )
    //             .then(response => {
    //               if (response.status === 200) {
    //                 this.suppliers = response.data.data.suppliers
    //                 this.supplier_filtered = this.suppliers
    //               }
    //             })
    //         }
    //       }
    //     })
    // },

    getSuppliers(event) {
      let name = ''
      let code = ''

      if (event.query != null && event.query.match(/^[a-zA-Z]+$/)) {
        name = event.query
      } else if (event.query.match(/^[a-zA-Z0-9]+$/)) {
        code = event.query
      }
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/suppliers?name=${name}&code=${code}&limit=5`
        )
        .then(response => {
          if (response.status === 200) {
            this.suppliers = response.data.data.suppliers
            let query = event.query
            let autoFiltered = []
            for (let i = 0; i < this.suppliers.length; i++) {
              let supplier = this.suppliers[i]
              if (
                supplier.name.toLowerCase().indexOf(query.toLowerCase()) === 0
              ) {
                autoFiltered.push(supplier)
              } else if (
                supplier.code.toLowerCase().indexOf(query.toLowerCase()) === 0
              ) {
                autoFiltered.push(supplier)
              }
            }
            this.supplier_filtered = autoFiltered
          }
        })
    },

    getItems() {
      let code = ''
      if (this.selected_item instanceof Object) {
        code = this.selected_item.code
      } else {
        code = this.selected_item
      }

      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/warehouse-items?code=${code}&limit=5`
        )
        .then(response => {
          if (response.status === 200) {
            this.items = response.data.data.items
          }
        })
    },

    searchItem(event) {
      this.filtered_items = this.items.filter(item => {
        return (
          item.name.toLowerCase().startsWith(event.query.toLowerCase()) ||
          item.code.toLowerCase().startsWith(event.query.toLowerCase())
        )
      })
    },
    getList() {
      let code = ''

      if (this.selected_item != 0) {
        code = this.selected_item.id
      } else {
        code = 0
      }

      this.$http
        .get(
          `${
            process.env.VUE_APP_API_URL
          }/dashboard/warehouse-sales?item_id=${code}&doc_number=${
            this.filter.doc_number
          }&doc_date=${this.filter.doc_date}&status=${1}`
        )
        .then(response => {
          if (response.status === 200) {
            this.list_items = response.data.data.warehouse_sales
          }
        })
    },

    saveClicked() {
      if (this.supplier_selected == null) {
        this.is_error.supplier_id = true
        this.error_msg.supplier_id = 'mohon pilih supplier'
      }
      if (this.process_data.doc_number == '') {
        this.is_error.doc_number = true
        this.error_msg.doc_number = 'mohon isi nomor bon'
      }
      if (this.process_data.doc_date == '') {
        this.is_error.doc_date = true
        this.error_msg.doc_date = 'mohon isi tanggal bon'
      }

      this.process_data.warehouse_sale_ids = this.ids
      if (this.supplier_selected != null) {
        this.process_data.sup_id = this.supplier_selected.id
      }

      if (
        this.process_data.sup_id != 0 &&
        this.is_error.doc_date == false &&
        this.is_error.doc_number == false
      ) {
        this.$http
          .post(
            `${process.env.VUE_APP_API_URL}/dashboard/purchase-orders/sales`,
            this.process_data
          )
          .then(response => {
            if (response.status === 200) {
              this.$toast.add({
                severity: 'success',
                summary: 'Submit items Obral Success',
                detail: 'Congrats, those items has been submitted',
                life: 3000
              })
              this.getList()
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Submit items Obral Failed',
                detail:
                  "Sorry, those items hasn't submitted. CHECK the stock first",
                life: 3000
              })
            }
            this.selected_item = null
            this.supplier_selected = null
            this.process_data = {
              warehouse_sale_ids: [],
              sup_id: 0,
              doc_date: '',
              doc_number: ''
            }
            this.process_dialog = false
          })
      }
    },

    prosesObral() {
      this.selectedItems_id = ''
      this.ids = []
      this.process_dialog = true
      if (this.selectedItems.length == 1) {
        this.selectedItems_id = this.selectedItems[0].id
        this.ids.push(this.selectedItems[0].id)
      } else {
        for (var i = 0; i < this.selectedItems.length; i++) {
          var item = this.selectedItems[i]
          this.ids.push(item.id)
          this.selectedItems_id += item.id
          if (i != this.selectedItems.length - 1) this.selectedItems_id += ','
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
